import * as React from 'react';

import { diagramModelSizesSelector } from 'src/selectors/diagramSnapshot';
import { PendingModelData } from 'src/store/state/projects';
import {
  getPendingModelDataSizes,
  isLargeModelSize,
} from 'src/utils/checkImportModelLimits';
import { useReduxSelector } from 'src/utils/hooks/useReduxSelector';
import { useRouterParams } from 'src/utils/hooks/useRouterParams';

/**
 * Whether adding `modelData` would push the project past the large-model
 * threshold.
 *
 * Counts the project's current diagram plus the incoming payload, and is shared
 * by the size warning in the import/upload panels and by the submit handler, so
 * the warning the user reads is exactly the condition that holds back the first
 * submit until it has been read (VET-7007).
 */
export const useWillImportBeLarge = () => {
  const { projectId } = useRouterParams();
  const currentModelSizes = useReduxSelector(
    diagramModelSizesSelector(projectId)
  );

  return React.useCallback(
    (modelData: Record<string, PendingModelData>) => {
      const incoming = getPendingModelDataSizes(modelData);
      return isLargeModelSize({
        classes: currentModelSizes.classes + incoming.classes,
        properties: currentModelSizes.properties + incoming.properties,
      });
    },
    [currentModelSizes]
  );
};
